import Vue from 'vue'
import Router from 'vue-router'
import TrackingView from './components/TrackingView'
import NotFound from './components/NotFound'

Vue.use(Router)
const routes = [
  {
    path: '/adrem/:id',
    name: 'adrem',
    component: TrackingView
  },
  {
    path: '/plasma/:id',
    name: 'plasma',
    component: TrackingView
  },
  {
    path: '/plasmapro/:id',
    name: 'plasmapro',
    component: TrackingView
  },
  {
    path: '/lapi/:id',
    name: 'lapi',
    component: TrackingView
  },
  { path: '/404', name: '404', component: NotFound },  
  { path: '*', redirect: '/404' }, 
]

const router = new Router({
  routes,
  linkActiveClass: 'active',
  base: '/',
  mode: 'history'
});

export default router
